import { useContext, useEffect, useState } from "react";
import { Instituicao } from "../../model/Instituicao";
import styles from "./styles.module.css";
import CampoSelect from "../Campo/CampoSelect";
import { UserContext } from "../../context/UserContext";
import putInstituicao from "../../services/putInstituicao";
import VerificaForm from "../../controllers/VerificaForm";
import Campo from "../Campo";

type Props = {
  instituicaoObj: any;
  setInstituicao: React.Dispatch<React.SetStateAction<Instituicao>>;
  closeModal: Function;
};

const EditSituacaoInstituicao = ({ instituicaoObj, setInstituicao, closeModal }: Props) => {
  const [situacaoInstituicao, setSituacaoInstituicao] = useState(instituicaoObj.status);
  const [observacaoInstituicao, setObservacaoInstituicao] = useState(situacaoInstituicao != "reprovada"? "" : instituicaoObj.observacao);

  const { token } = useContext(UserContext);

  const salvarDados = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const editarInstituicao = async () => {
      try {
        const r = await putInstituicao(token, instituicaoObj.cnpj, situacaoInstituicao, situacaoInstituicao != "reprovada"? "Sem observações" : observacaoInstituicao);    
        setInstituicao({
          cnpj: instituicaoObj.cnpj,
          email: instituicaoObj.email,
          nome: instituicaoObj.nome,
          observacao: r.observacao || observacaoInstituicao || instituicaoObj.observacao,
          status: situacaoInstituicao || instituicaoObj.status,
          telefone: instituicaoObj.telefone,
          cep: instituicaoObj.cep,
          estado: instituicaoObj.estado,
          cidade: instituicaoObj.cidade,
          bairro: instituicaoObj.bairro,
          rua: instituicaoObj.rua,
          numero: instituicaoObj.numero,
          complemento: instituicaoObj.complemento,
        });
      } catch (err) {
        console.log("Erro ao editar situação da Instituição ", err);
      }
    };
    if (VerificaForm(e.currentTarget.form)) {
      editarInstituicao();
      closeModal();
    }
  }; 

  return (
    <form className={styles.formModal} onSubmit={salvarDados}>
      <h2>Alterar situação da Instituição</h2>
      <div className={styles.camposDados}>
        <hr />
        <div className={styles.gridCampos}>
          <span className={styles.tuplaDado}>
            <strong>Nome da Instituição:</strong> {instituicaoObj.nome}
          </span>
          <span className={styles.tuplaDado}>
            <strong>CNPJ:</strong> {instituicaoObj.cnpj}
          </span>
        </div>
        <hr />
        <div className={styles.gridCampos}>
        <CampoSelect title="Situação" setter={setSituacaoInstituicao} value={situacaoInstituicao}>
          <option value="pendente">Pendente</option>
          <option value="aprovada">Aprovada</option>
          <option value="reprovada">Reprovada</option>
        </CampoSelect>
        {situacaoInstituicao == "reprovada" && 
        <Campo
            title="Observação"
            type="text"
            placeholder="Motivo da reprovação"
            required={true}
            value={observacaoInstituicao}
            setter={setObservacaoInstituicao}
            customValidity="Preencha a observação para a reprovação da Instituição"
          ></Campo>
        }
        </div>
        <hr />
      </div>
      <input type="submit" value="Editar Situação" />
    </form>
  );
};

export default EditSituacaoInstituicao;
